import { __assign } from "tslib";
import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import ProjectComponent from '../components/Project';
import NotFound from '../components/NotFound';
import Password from './Password';
import { isInAnnotationMode } from '../selectors/annotation';
import { isInHandoffMode, isHandoffAvailable } from '../selectors/handoff';
import * as grid from '../selectors/grid';
function Project(props) {
    var isPasswordRequired = props.isPasswordRequired, isPasswordValid = props.isPasswordValid, notFound = props.notFound, isLoading = props.isLoading, onMobileDevice = props.onMobileDevice;
    if (isPasswordRequired && !isPasswordValid) {
        return React.createElement(Password, null);
    }
    if (notFound) {
        return React.createElement(NotFound, null);
    }
    if (isLoading) {
        return null;
    }
    return React.createElement(ProjectComponent, __assign({ onMobileDevice: onMobileDevice }, props));
}
Project.propTypes = {
    isPasswordRequired: PropTypes.bool,
    isPasswordValid: PropTypes.bool,
    notFound: PropTypes.bool,
    isLoading: PropTypes.bool,
    onMobileDevice: PropTypes.bool,
    rotate: PropTypes.bool,
};
var mapStateToProps = function (state) { return (__assign(__assign({}, state.project.config), { isInAnnotationMode: isInAnnotationMode(state), isInHandoffMode: isInHandoffMode(state), isHandoffAvailable: isHandoffAvailable(state), areCommentsVisible: state.comment.areVisible, isEmbedded: state.project.isEmbedded, isInTheExploreView: state.project.isInTheExploreView, isLoading: state.project.isLoading && !state.player.isAboutToPlay, notFound: state.project.notFound, isPasswordRequired: state.password.isRequired, isPasswordValid: state.password.isValid, showGridNav: grid.isOpen(state), onMobileDevice: state.deviceDetection.isMobile, isDownloaded: state.project.isDownloaded, isFrameless: state.project.isFrameless, isBasic: state.project.isBasic })); };
export default connect(mapStateToProps)(Project);
